import React from "react"
import { useQuery } from "@tanstack/react-query"
import api from "../../services/api"
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card"
import { Skeleton } from "../ui/skeleton"
import { FreshnessBadge } from "../StatusBadge"
import { Database } from "lucide-react"

function DatabaseStatus() {
  const { data: updateDates, isLoading } = useQuery({
    queryKey: ["database-update-dates"],
    queryFn: () => api.getDatabaseUpdateDates(),
    staleTime: 6 * 60 * 60 * 1000, // 6 hours
  })

  const formatDate = (dateString) => {
    if (!dateString) return "Unknown"
    try {
      const date = new Date(dateString)
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    } catch {
      return dateString
    }
  }

  const getDaysAgo = (dateString) => {
    if (!dateString) return null
    try {
      const date = new Date(dateString)
      const now = new Date()
      const diffTime = Math.abs(now - date)
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
      return diffDays
    } catch {
      return null
    }
  }

  if (isLoading) {
    return (
      <Card>
        <CardHeader className="pb-3">
          <CardTitle className="text-lg flex items-center gap-2">
            <Database className="h-5 w-5" />
            Database Status
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <Skeleton className="h-20 w-full" />
            <Skeleton className="h-20 w-full" />
          </div>
        </CardContent>
      </Card>
    )
  }

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-lg flex items-center gap-2">
          <Database className="h-5 w-5" />
          Database Status
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {/* Open Food Facts */}
          <div className="flex items-center justify-between p-4 border rounded-lg">
            <div className="flex items-center gap-3">
              <div className="h-10 w-10 rounded-full bg-orange-100 dark:bg-orange-900/30 flex items-center justify-center">
                <Database className="h-5 w-5 text-orange-600 dark:text-orange-400" />
              </div>
              <div>
                <p className="font-medium">Open Food Facts</p>
                <p className="text-sm text-muted-foreground">
                  {formatDate(updateDates?.off)}
                </p>
              </div>
            </div>
            <FreshnessBadge daysAgo={getDaysAgo(updateDates?.off)} />
          </div>
        </div>
      </CardContent>
    </Card>
  )
}

export default DatabaseStatus
